import React, { useEffect, useRef, useState } from "react";
import DefaultButton from "../../styles/materialButtonStyle";
import { Input, InputLabel } from "@material-ui/core";
import CircularProgress from "@material-ui/core/CircularProgress";
import FormHelperText from "@material-ui/core/FormHelperText";
import ValidationFormControl from "../../styles/materialValidFormControl";

import { StyledTwoFaWrapper } from "./styledTwoFa";
import { useTranslation } from "react-i18next";

const TWO_FA_CODE_LENGTH = 6;

const TwoFa = ({ handleSubmit, error, loading = false, autoSubmit = false, label = null, children }) => {
  const { t } = useTranslation("loginPage");

  const [code, setCode] = useState("");
  const inputRef = useRef(null);
  const formRef = useRef(null);

  const sanitize = (value) => value.replace(/\D/g, "").slice(0, TWO_FA_CODE_LENGTH);

  const handleChangeValue = (event) => {
    setCode(sanitize(event.target.value));
  };

  const handlePasteValue = (event) => {
    event.preventDefault();
    const text = (event.clipboardData || window.clipboardData).getData("text");
    setCode(sanitize(text));
  };

  useEffect(() => {
    window.scrollTo(0, 0);

    if (inputRef.current) {
      inputRef.current.focus();
    }
  }, []);

  // requestSubmit, а не handleSubmit() напряму: обробники в консюмерах читають event.target.twofa.value
  useEffect(() => {
    if (code.length === TWO_FA_CODE_LENGTH && autoSubmit) {
      formRef.current.requestSubmit();
    }
  }, [code]);

  return (
    <StyledTwoFaWrapper ref={formRef} onSubmit={handleSubmit}>
      <ValidationFormControl
        error={error.email && true}
        className="twofa-field-group"
      >
        <InputLabel htmlFor="twofa">{label || t("twofaCode")}</InputLabel>
        <Input
          id="twofa"
          required
          type="text"
          name="twofa"
          value={code}
          onChange={handleChangeValue}
          onPaste={handlePasteValue}
          inputRef={inputRef}
          inputProps={{
            maxLength: TWO_FA_CODE_LENGTH,
            inputMode: "numeric",
            pattern: "\\d{6}",
            enterKeyHint: "done",
          }}
          autoComplete="one-time-code"
          className="twofa-field-group__input"
        />
        {error.twofa && <FormHelperText id="component-error-text">{error.twofa}</FormHelperText>}
      </ValidationFormControl>
      <div className="twofa-action">
        <DefaultButton
          color="success"
          type="submit"
          disabled={loading || code.length !== TWO_FA_CODE_LENGTH}
          startIcon={loading ? <CircularProgress size={18} color="inherit" /> : null}
        >
          {t("twofaConfirm")}
        </DefaultButton>
        {children}
      </div>
    </StyledTwoFaWrapper>
  );
};

export default TwoFa;